module.exports = __webpack_public_path__ + "img/delete-table-icon.bdf8e16c.svg";